<template>
  <div class="video-wrapper">
    <a
      v-if="showCloseButton"
      class="modal-close-button"
      @click="closeModal"
      v-html="buttonClose"
    >
    </a>
    <div class="video-container">
      <video ref="videomedia" width="853" height="480" playsinline></video>
    </div>
    <div class="player-container">
      <div class="play-control">
        <div
          class="play-button icon-video-play"
          v-bind:class="{ hide: videoPlaying }"
          v-on:click.prevent="playVideo"
        ></div>
        <div
          class="pause-button icon-video-pause"
          v-bind:class="{ hide: !videoPlaying }"
          v-on:click.prevent="pauseVideo"
        ></div>
      </div>
      <div class="timeline">
        <div class="progress-background icon-video-timeline">
          <div class="icon-video-scrubber"></div>
        </div>
      </div>
      <div class="volume-control">
        <div
          class="volume-button icon-video-audio-on"
          v-bind:class="{ hide: videoMuted }"
          v-on:click.prevent="muteAudio"
        ></div>
        <div
          class="volume-button-mute icon-video-audio-off"
          v-bind:class="{ hide: !videoMuted }"
          v-on:click.prevent="unmuteAudio"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import TweenMax from 'gsap';
import { mapState, mapMutations, mapGetters } from 'vuex';
import btnClose from 'assets/svg/btn-close.svg';

export default {
  computed: {
    ...mapState('application', {
      isMobile: state => state.device.device
    }),

    ...mapState('application', ['video', 'isVideoPathAbsolute']),

    ...mapGetters('application', ['usingExternalKeyboard'])
  },

  watch: {
    video() {
      this.setTheVideo(this.video, this.isMobile);
    }
  },

  data() {
    return {
      videoPlaying: false,
      videoMuted: false,
      videoDone: false,
      videoRef: '',
      buttonClose: btnClose,
      scrubberX: '',
      showCloseButton: true
    };
  },
  methods: {
    ...mapMutations('application', ['setModal']),

    setTheVideo(videoName) {
      const source = document.createElement('source');
      const videoSrc = videoName;
      source.setAttribute('src', videoSrc);
      this.videoRef = this.$refs.videomedia;
      this.videoRef.appendChild(source);
      const promise = this.videoRef.play();

      if (promise !== undefined) {
        promise
          .then(() => {
            // Play started, update play button
            this.videoPlaying = true;
          })
          .catch(() => {
            this.videoPlaying = false;
          });
      }

      this.videoRef.addEventListener(
        'timeupdate',
        this.videoTimeUpdated,
        false
      );
    },

    closeModal() {
      this.pauseVideo();
      this.setModal(undefined);
    },

    pauseVideo() {
      this.videoPlaying = false;
      this.videoRef.pause();
    },

    playVideo() {
      this.videoPlaying = true;
      this.videoRef.play();
    },

    muteAudio() {
      this.videoMuted = true;
      this.videoRef.muted = true;
    },

    unmuteAudio() {
      this.videoMuted = false;
      this.videoRef.muted = false;
    },

    videoTimeUpdated() {
      this.videoEndCheck();
      this.scrubberX =
        Math.floor((this.videoRef.currentTime / this.videoRef.duration) * 600) -
        16;
      TweenMax.set('.icon-video-scrubber', {
        css: { left: `${this.scrubberX}px` }
      });
    },

    videoEndCheck() {
      if (this.videoRef.currentTime >= this.videoRef.duration) {
        this.videoPlaying = false;
        this.videoDone = true;
        this.videoRef.removeEventListener(
          'timeupdate',
          this.videoTimeUpdated,
          false
        );
        this.setModal(undefined);
      }
    }
  }
};
</script>
